import React from 'react'
import ListItem from './ListItem'

export default ({ docs, firebase }) =>
  docs.map((doc, i) => (
    <ListItem key={i} doc={doc} index={i} firebase={firebase} />
  ))
